import { render } from "./MengikutJenisKaunter.vue?vue&type=template&id=0b223c23"
import script from "./MengikutJenisKaunter.vue?vue&type=script&lang=js"
export * from "./MengikutJenisKaunter.vue?vue&type=script&lang=js"

import "./MengikutJenisKaunter.vue?vue&type=style&index=0&id=0b223c23&lang=css"
import "./MengikutJenisKaunter.vue?vue&type=style&index=1&id=0b223c23&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__